document.addEventListener("DOMContentLoaded", () => {
  const pdfElements = document.querySelectorAll("[data-pdf]");

  pdfElements.forEach(async (el) => {
    const url = el.getAttribute("data-pdf");
    if (!url) return;

    const pdf = await pdfjsLib.getDocument(url).promise;
    const totalPages = pdf.numPages;

    let currentPage = 1;

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    el.appendChild(canvas);

    const controls = document.createElement("div");
    controls.classList.add('pdf-pagination');
    controls.innerHTML = `
      <button data-prev>◀</button>
      <span data-page>1 / ${totalPages}</span>
      <button data-next>▶</button>
    `;
    el.appendChild(controls);

   async function renderPage(num) {
  const page = await pdf.getPage(num);
  const scale = 2 * window.devicePixelRatio;
  const viewport = page.getViewport({ scale });

  canvas.width = viewport.width;
  canvas.height = viewport.height;

  await page.render({
    canvasContext: ctx,
    viewport
  }).promise;

  // Update page text
  controls.querySelector("[data-page]").textContent = `${num} / ${totalPages}`;

  // Disable / enable buttons
  const prevBtn = controls.querySelector("[data-prev]");
  const nextBtn = controls.querySelector("[data-next]");

  prevBtn.disabled = num === 1;
  nextBtn.disabled = num === totalPages;
}


    controls.querySelector("[data-prev]").onclick = () => {
      if (currentPage > 1) {
        currentPage--;
        renderPage(currentPage);
      }
    };

    controls.querySelector("[data-next]").onclick = () => {
      if (currentPage < totalPages) {
        currentPage++;
        renderPage(currentPage);
      }
    };

    renderPage(currentPage);
  });
});
